import { createSelector } from 'reselect'

import { hasMultiLocalCurrencies } from '../helpers/parseActualsMultiCurrency'

import { selectCurrencyData } from './selectCurrencyData'

export const selectHasMultiLocalCurrencies = createSelector(
  [selectCurrencyData],
  ({ actualsMultiCurrency }) => hasMultiLocalCurrencies(actualsMultiCurrency)
)
